import { useEffect, useState } from "react";
import { set, useFormContext, useWatch } from "react-hook-form";

export default function SeatsConfig({
  inputClasses,
  labelClasses,
  helperClasses,
  isCollapsible,
  isUpgrade,
}) {
  const { register, setValue } = useFormContext();
  const seats = useWatch({ name: "seats" });
  const enrichment = useWatch({ name: "enrichment" });

  useEffect(() => {
    setValue("seats.freeSeatsEnabled", enrichment?.enabled, { shouldDirty: true });
    if (!isUpgrade && enrichment?.enabled && Number.parseInt(seats.paid, 10)) {
      const diff = seats.paid - 150;
      if (diff <= 0) {
        setValue("seats.free", 150, { shouldDirty: true });
        setValue("seats.paid", 0, { shouldDirty: true });
      } else {
        setValue("seats.free", 150, { shouldDirty: true });
        setValue("seats.paid", Math.abs(diff), { shouldDirty: true });
      }
    }
  }, [enrichment?.enabled]);

  const exlcudableBlock = isCollapsible && (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center">
        <input
          {...register("seats.enabled")}
          id="seats-enabled"
          type="checkbox"
          checked={seats.enabled}
          onChange={(e) => setValue("seats.enabled", e.target.checked, { shouldDirty: true })}
          className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <label htmlFor="seats-enabled" className="ml-3 text-sm font-semibold text-gray-900">
          Include seats credits in subscription
        </label>
      </div>
    </div>
  );
  return (
    <div>
      {exlcudableBlock}
      {(!isCollapsible || seats.enabled) && (
        <div>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label htmlFor="seats-paid" className={labelClasses}>
                Paid seats
              </label>
              <input
                {...register("seats.paid")}
                id="seats-paid"
                type="number"
                min="0"
                value={seats.paid}
                onChange={(e) => setValue("seats.paid", Number.parseInt(e.target.value, 10), {
                  shouldDirty: true,
                })
                }
                className={inputClasses}
              />
            </div>

            {!isCollapsible && seats.freeSeatsEnabled && (
              <div>
                <label htmlFor="seats-free" className={labelClasses}>
                  Free seats
                </label>
                <input
                  {...register("seats.free")}
                  id="seats-free"
                  type="number"
                  value={seats.free}
                  onChange={(e) => setValue("seats.free", Number.parseInt(e.target.value, 10), {
                    shouldDirty: true,
                  })
                  }
                  className={inputClasses}
                  disabled={!seats.freeSeatsEnabled}
                />
              </div>
            )}
          </div>

          <div className="pt-4 border-t border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <label className="block text-sm font-medium text-gray-900">Custom seat pricing</label>
              <div className="flex items-center">
                <input
                  {...register("seats.hasCustomPricing")}
                  id="seats-custom-pricing"
                  type="checkbox"
                  checked={seats.hasCustomPricing}
                  onChange={(e) => setValue("seats.hasCustomPricing", e.target.checked, { shouldDirty: true })
                  }
                  className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-900"
                />
                <label
                  htmlFor="seats-custom-pricing"
                  className="ml-2 text-sm font-medium text-gray-700"
                >
                  Enable custom per seat pricing
                </label>
              </div>
            </div>

            {seats.hasCustomPricing ? (
              <div>
                <div className="relative">
                  <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                    $
                  </span>
                  <input
                    {...register("seats.dollars", {
                      valueAsNumber: true,
                    })}
                    id="seats-dollars"
                    type="number"
                    step="0.01"
                    min="0"
                    className={`${inputClasses} pl-7`}
                    placeholder="0.00"
                  />
                </div>
                <div id="seats-dollars-help" className={helperClasses}>
                  Custom per-seat dollars in dollars.
                </div>
              </div>
            ) : (
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <p className="text-sm text-gray-600">Using server default pricing for seats</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
